/**
 * RESPONSIBILITY: the mission statement band on the home page.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Link, List, RenderOf } from '@framework/core/decorators';
import { WelcomeTag } from './rows/welcome-tag';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.HomeMission, label: 'Home · Mission' })
export class HomeMissionSection {
  @Text({
    label: 'Subtitle', maxLength: 300,
    description: 'The small line above the title.',
  })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 600 })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 20000, rows: 5, markdown: true, allow: ['verse'] })
  body!: string;

  @RenderOf('body')
  bodyHtml!: string;


  /** The line the brand deck runs across the bottom of this panel, in the script face. */
  @Text({
    label: 'Tagline', maxLength: 600,
    description: 'The handwritten line across the bottom of the panel.',
  })
  tagline!: string;

  /**
   * Under the tags rather than in the service card. The card answers when and how; this
   * answers where, and it belongs with the invitation rather than with the practicals.
   */
  @Text({
    label: 'Address', maxLength: 300,
    description: 'Where to come on a Sunday. Shown under the tags, with a pin.',
  })
  address!: string;

  /**
   * Separate from the address because the two are not the same value: the words are what
   * a visitor reads and the link is where a phone should send them. Empty leaves the
   * address as plain words, which is right until somebody has a map to point at.
   */
  @Link({
    label: 'Map link',
    description: 'Opens when somebody taps the address. Empty leaves it as plain words.',
  })
  addressHref!: string;

  @List({
    label: 'What to expect', of: () => WelcomeTag, maxItems: 6,
    description: 'The short row of tags under the welcome — what somebody is glad to know before a first visit.',
  })
  tags!: WelcomeTag[];

  @Text({
    label: 'Service name', maxLength: 120, default: 'Sunday worship',
    group: 'The service card',
  })
  serviceLabel!: string;

  @Text({ label: 'Time', maxLength: 60, group: 'The service card', description: 'e.g. 10:00 AM.' })
  serviceTime!: string;

  @Text({
    label: 'Line under the time', maxLength: 200, group: 'The service card',
    description: 'e.g. In person and online. Doors open at 9:30.',
  })
  serviceNote!: string;

  @Text({ label: 'Button text', maxLength: 120, default: 'Plan your visit', group: 'The service card' })
  ctaLabel!: string;

  @Link({ label: 'Button link', group: 'The service card', description: LINK_HINT })
  ctaHref!: string;
}
